import React, { useState, useRef, useContext } from 'react'
import styles from './ContactoAdicional.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'
//Utiles
import * as Constantes from '../../utils/constantes'

const ContactoAdicional = ({ aseguradoAdicional, state, setState }) => {
  
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const handleChangeText = (e, campo) => {
    let valor = e.target.value
    setState((state) => {
      return {
        ...state,
        aseguradoAdicional: {
          ...state.aseguradoAdicional,
          [campo]: valor
        },
        campoValidadoAdicional: {
          ...state.campoValidadoAdicional,
          [campo]: true
        },
        noBloqueo: campo === 'correoElectronico' ? false : state.noBloqueo
      }
    })
  }

  const handleChangeNumber = (e, campo) => {
    let valor = e.target.value.replace(/\D/g, '')
    setState((state) => {
      return {
        ...state,
        aseguradoAdicional: {
          ...state.aseguradoAdicional,
          [campo]: parseInt(valor)
        },
        campoValidadoAdicional: {
          ...state.campoValidadoAdicional,
          [campo]: true
        },
        noBloqueo: false
      }
    })
  }

  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className={styles['areadatosprospecto']}>
      <Subtitle sname='Contacto' smostrar='false' />
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div className={styles['area50']}>
          <label>Celular&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidadoAdicional.telefonoMovil ? styles['logerror'] : null}
            type='text'
            value={aseguradoAdicional !== null && aseguradoAdicional !== undefined ? aseguradoAdicional.telefonoMovil || '' : ''}
            maxLength={9}
            onChange={(e) => handleChangeNumber(e, 'telefonoMovil')}
            style={{ paddingLeft: "4%" }}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidadoAdicional.telefonoMovil ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_NUM_CELULAR}
            </span>
          ) : null}
        </div>
        <div className={styles['area75']}>
          <label>Correo Electrónico&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidadoAdicional['correoElectronico'] ? styles['logerror'] : null}
            type='text'
            value={aseguradoAdicional !== null && aseguradoAdicional !== undefined ? aseguradoAdicional.correoElectronico || '' : ''}
            maxLength={60}
            onChange={(e) => handleChangeText(e, 'correoElectronico')}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidadoAdicional['correoElectronico'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL}
            </span>
          ) : null}
          {state.campoValidadoAdicional['emailRepetido'] !== undefined && !state.campoValidadoAdicional['emailRepetido'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL_REPETIDO}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ContactoAdicional
